import CryptoJS from "crypto-js";
import AppConfig from "../config/AppConfig";

export default class ViewFileHelp{
  static getViewFileUrl(src,duration_time=86400,bucket="gdza"){
    let wordArray = CryptoJS.enc.Utf8.parse(src);
    let word=CryptoJS.enc.Base64.stringify(wordArray);
    //'http://api.gdzawy.com:9013/onlinePreviewObject?url='+encodeURIComponent(word)+'&bucket='+bucket+'&duration_time='+duration_time
    return AppConfig.os_server+'onlinePreviewObject?url='+encodeURIComponent(word)+'&bucket='+bucket+'&duration_time='+duration_time
  }
}



// WEBPACK FOOTER //
// ./src/common/ViewFileHelp.js